export default function defaultMetricsParams(_canUseMetrics) {
  // canUseMetrics is very useful property if you trying to set default metrics.
  // You probably will need it cause we show metrics mostly for paid users.
  return {
    dlsGroupMode: 'one_per_domain',
    format: null,
  };
}
